import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { useAdvancedShippingNoticeContext } from '../../../../advanced-shipping-notice-context';
import { messages } from '../messages';

const BoxPalletNumberCell = ({ row }) => {
  const { isHeader, boxNumberDisplay } = row?.original || {};

  if (isHeader) {
    return null;
  }

  return boxNumberDisplay;
};

const HeaderCell = () => {
  const { isParcelConfiguration } = useAdvancedShippingNoticeContext();

  if (isParcelConfiguration) {
    return <FormattedMessage {...messages.boxNumberColumnHeader} />;
  }
  return <FormattedMessage {...messages.palletNumberColumnHeader} />;
};

export const createBoxPalletNumberColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'boxNumberDisplay',
  Header: <HeaderCell />,
  Cell: BoxPalletNumberCell,
  width: 0.75,
});
